// Generated by ts-to-zod
import { z } from 'zod'

import { BLOCK_TYPE } from '../../../types/next/enums'

import {
  addressValueSchema,
  geoAddressValueSchema,
  unlistedAddressValueSchema
} from './addresses.zod'
import { iBlockSchema, blockBaseSettingsSchema } from './baseBlock.zod'
import { referenceIdSchema } from './ids.zod'
import { commonFieldSettingsSchema } from './personalInformationBlock.zod'
import { blockReferenceSchema } from './references.zod'

const baseSettingsSchema = z.object({
  fields: z.object({
    zipCity: commonFieldSettingsSchema,
    suburb: commonFieldSettingsSchema,
    streetName: commonFieldSettingsSchema,
    houseNumber: commonFieldSettingsSchema,
    extention: commonFieldSettingsSchema
  }),
  autocomplete: z.object({
    enabled: z.boolean(),
    countryCode: z.string().optional(),
    allowFreeText: z.boolean().optional()
  }),
  mapIntegration: z.object({
    enabled: z.boolean(),
    repositionAllowed: z.boolean()
  }),
  api: z.string().optional()
})

export const addressUnlistedFieldsSchema = z.object({
  zipCity: commonFieldSettingsSchema,
  suburb: commonFieldSettingsSchema,
  plotArea: commonFieldSettingsSchema,
  plotOfLand: commonFieldSettingsSchema
})

export const availabilityCheckAutofillReferenceSchema =
  blockReferenceSchema.extend({
    meaning: z.literal('availability-check-autofill')
  })

export const iAddressBlockSchema = iBlockSchema.extend({
  type: z.literal(BLOCK_TYPE.ADDRESS),
  settings: blockBaseSettingsSchema.and(baseSettingsSchema).and(
    z.object({
      unlistedFields: z
        .union([z.never(), addressUnlistedFieldsSchema])
        .optional()
    })
  ),
  references: z.record(
    referenceIdSchema,
    availabilityCheckAutofillReferenceSchema
  )
})

export const regularAddressBlockSchema = iAddressBlockSchema.extend({
  settings: blockBaseSettingsSchema.and(baseSettingsSchema).and(
    z.object({
      supportUnlisted: z.literal(false),
      unlistedFields: z.never().optional()
    })
  )
})

export const unlistedAddressBlockSchema = iAddressBlockSchema.extend({
  settings: blockBaseSettingsSchema.and(baseSettingsSchema).and(
    z.object({
      supportUnlisted: z.literal(true),
      unlistedFields: addressUnlistedFieldsSchema
    })
  )
})

export const addressBlockSchema = z.union([
  regularAddressBlockSchema,
  unlistedAddressBlockSchema
])

export const iAddressSchema = z.object({})

export const addressBlockValueSchema = addressValueSchema
  .extend(geoAddressValueSchema.shape)
  .extend(unlistedAddressValueSchema.shape)
  .extend({
    suburb: z.string().optional().nullable(),
    extension: z.string().optional().nullable(),
    addressExtention: z.string().optional().nullable(),
    streetName: z.string().optional().nullable(),
    houseNumber: z.string().optional().nullable(),
    extention: z.string().optional().nullable(),
    companyName: z.string().optional().nullable()
  })
